type Point = { title: string; body: string };

type Props = {
    authorNote: string;
    heading: string;
    intro: string;
    chips: string[];
    points: Point[];
};

// Full-bleed dark editorial block for a guide's "how I actually do this
// myself" section — the opinion-led lead-in before the general playbook.
export default function GuideOpinionLead({
    authorNote,
    heading,
    intro,
    chips,
    points,
}: Props) {
    return (
        <section className="gt-guide-opinion">
            <svg
                className="gt-guide-opinion__route"
                viewBox="0 0 900 60"
                preserveAspectRatio="none"
                aria-hidden="true"
            >
                <path d="M-10 40 Q 220 8 460 26 T 920 16" />
            </svg>
            <div className="gt-guide-opinion__inner">
                <div className="gt-guide-opinion__byline">
                    <span className="gt-guide-opinion__avatar" aria-hidden="true">
                        S
                    </span>
                    <div>
                        <div className="gt-eyebrow gt-guide-opinion__eyebrow">
                            My take
                        </div>
                        <div className="gt-guide-opinion__note">{authorNote}</div>
                    </div>
                </div>
                <h2 className="gt-guide-opinion__heading">{heading}</h2>
                <p className="gt-guide-opinion__intro">{intro}</p>
                <div className="gt-guide-opinion__chips">
                    {chips.map((chip) => (
                        <span key={chip} className="gt-guide-opinion__chip">
                            {chip}
                        </span>
                    ))}
                </div>
                <div className="gt-guide-opinion__points">
                    {points.map((point, i) => (
                        <div key={point.title} className="gt-guide-opinion__point">
                            <span className="gt-guide-opinion__point-num">
                                {String(i + 1).padStart(2, "0")}
                            </span>
                            <div>
                                <h3 className="gt-guide-opinion__point-title">
                                    {point.title}
                                </h3>
                                <p className="gt-guide-opinion__point-body">
                                    {point.body}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
